import React from 'react';

const WelcomeSection = () => {
  // removed welcome message per design
  return null;
};

export default WelcomeSection;
